import React from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../home/header/Header';
import Menubar from '../home/menubar/Menubar';
import Address from '../home/footer/Address';
import ScrollToTopProgress from '../home/header/ScrollToTopProgress';
import './msquiz.css'
import { quizImg } from './quizdata';

function Quiz() {

    const Navigate = useNavigate();
    const quizUrl = (examId) => {
      Navigate('/quiz-startquiz', {state: {examId}, replace: true});  
    };
  return (
    <div>
        <Header/>
        <Menubar/>
        <div className='container exam-container'>
        <div className='left-quizcontainer'>
            <div style={{top: '50px'}}>
              <h2>Please select your Quiz Test</h2>
            </div>
            <div className="select-quiz">
                <button onClick={() => quizUrl('msOffice')} className='button'>Ms.Office</button>
                <button onClick={() => quizUrl('dtp')} className='button'>DTP</button>
                <button onClick={() => quizUrl('cLanguage')} className='button'>C-Language</button>  
            </div>
        </div>
        <div className="col-md-6 right-quizcontainer">
          <img src={quizImg.examUrl} alt="ExamUrl" style={{borderRadius: '20px 60px'}}/>
        </div>
        </div>
        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Quiz